var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconContrastH(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000124120573602784669040000005558161753209280658_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 114 114",
    style: {
      enableBackground: "new 0 0 114 114"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57,32.7c-13.4,0-24.3,10.9-24.3,24.3S43.6,81.3,57,81.3S81.3,70.4,81.3,57S70.4,32.7,57,32.7z M57,38.7 v36.6c-10.1,0-18.3-8.2-18.3-18.3S46.9,38.7,57,38.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.8,60.5c-0.1-1.2-0.2-2.3-0.2-3.5v-1.8l-14-0.3v1c0,0.4,0,0.7,0,1.1c0,1.6,0.1,3.3,0.2,4.8v1.1h1.1L17,62 l4.8-0.3V60.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.5,34.6c0.8-1,1.7-1.9,3-3.2l0.7-0.7l-9.7-10.1l-0.7,0.7c-1.5,1.4-2.8,2.9-4.1,4.4l-0.6,0.8l10.8,8.9 L29.5,34.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.5,21.8L53.5,21.8c1.5-0.1,2.9-0.2,4.3-0.2h1l0.3-14h-1c-2,0-4,0-5.9,0.2L51,7.9l1.6,13.8L53.5,21.8 L53.5,21.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.6,32.5l0.7,0.7l10.1-9.7l-0.7-0.7c-1.5-1.5-3-2.9-4.5-4.1l-0.8-0.6l-8.8,10.8l0.8,0.6 C80.5,30.5,81.5,31.4,82.6,32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.4,79.5c-0.9,1.1-1.9,2.2-3,3.2l-0.7,0.7l9,9.4L90,93h0.8l0.3-0.3c1.5-1.4,2.8-2.9,4.1-4.4l0.6-0.8 L85,78.7L84.4,79.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.2,52.2l-0.1-1.3l-13.9,1.6l0.1,1c0.1,1.2,0.2,2.4,0.2,3.5v1.8l13,0.3h1v-1c0-0.4,0-0.8,0-1.2 C106.4,55.4,106.3,53.8,106.2,52.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.7,92.2h-0.9h-0.3c-1.4,0.1-2.8,0.2-4.3,0.2h-1l-0.3,12h-0.4l0.4,0.4v1.6h1c0.4,0,0.7,0,1.1,0h2.5 l-0.1-0.1c0.8,0,1.6-0.1,2.4-0.2h1.1L62,98L61.7,92.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.4,81.4l-0.7-0.7l-10.1,9.7l0.7,0.7c1.4,1.5,2.9,2.9,4.4,4.1l0.7,0.6l0.6-0.6L35.3,85l-0.8-0.6 C33.4,83.4,32.4,82.5,31.4,81.4z"
  })), /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st1",
    width: 114,
    height: 114
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContrastH);
export default __webpack_public_path__ + "static/media/icon_contrast_h.2a239f896add1cc780b64252bfc587f0.svg";
export { ForwardRef as ReactComponent };